<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div *ngFor="let text of data.bodyContent">
    <span class="{{text.class}}">{{ text.text }}</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close type="button">{{ 'COMMON.Close' | translate }}</button>
</mat-dialog-actions>